import React, { memo } from 'react';
import './DropDownSignataires.css';

interface Signataire {
  id: number;
  id_user?: number;
  nom: string;
  prenom: string;
  type_signataire: string;
}

interface DropDownSignatairesProps {
  signataires: Signataire[];
  value: number | null;  // Cette valeur représente id_user
  onChange: (id: number, type_signataire: string) => void;
  loading?: boolean;
  error?: string | null;
}

const DropDownSignataires: React.FC<DropDownSignatairesProps> = ({
  signataires,
  value,
  onChange,
  loading = false,
  error = null
}) => {
  console.log("[DropDownSignataires] Rendu avec", { 
    signatairesCount: signataires.length,
    selectedIdUser: value,
    signataires
  });

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedIdUser = parseInt(e.target.value, 10);
    console.log("[DropDownSignataires] Sélection changée, id_user:", selectedIdUser);
    
    if (!isNaN(selectedIdUser)) {
      const selected = signataires.find(s => s.id_user === selectedIdUser);
      if (selected) {
        console.log("[DropDownSignataires] Signataire trouvé:", selected);
        onChange(selected.id, selected.type_signataire);
      }
    }
  };

  return (
    <div className="dropdown-signataires">
      {loading && <p>Chargement des signataires...</p>}
      {error && <p className="error-message">Erreur: {error}</p>}
      {!loading && !error && (
        <select 
          value={value || ''}
          onChange={handleChange}
          className="signataire-select"
        >
          <option value="">-- Sélectionner un signataire --</option>
          {signataires.map(sig => (
            <option key={`sig-${sig.id_user}`} value={sig.id_user}>
              {sig.prenom} {sig.nom} ({sig.type_signataire})
            </option>
          ))}
        </select>
      )}
    </div>
  );
};

export default memo(DropDownSignataires);